module.exports = __webpack_public_path__ + "images/daytrading-d1b069.png";